import React from 'react'
import {
    UiOrderDetails,
    UiOrderDetailsColWr,
    UiOrderDetailsColName,
    UiOrderDetailsHr,
    UiOrderDetailsColStatus,
    UiOrderDetailsColValidUnit,
    UiOrderDetailsColLabel,
    UiOrderDetailsLastColWr,
    UiOrderDetailsLastCol,
    UiOrderDetailsLastColBtnWr,
    UiVoucherDetailsWr,
    UiProductContent,
    UiProductContentMainTitle,
    UiProductContentSubTitle,
    UiProductContentDescription,
    UiHistoricGoalColStatus
} from "../../../components/common/UiProductElements"
import { UiButtonPrimary, UiButtonIcon } from "../../../components/form/UiButton"
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import London from "../../../../../styles/img/london-img.jpg"
import VoucherWalletContent from '../../Shop/Views/VoucherWalletContent'

export default function HistoricGoalCard(props) {

    return (
        <>
            <UiVoucherDetailsWr>
                <UiOrderDetails>
                    <UiSingleRow>
                        <UiCol lg="4">
                            <UiOrderDetailsColWr>
                                <UiOrderDetailsColName colName="Goal Name" />
                                <UiOrderDetailsColLabel label="Stag Night" />
                            </UiOrderDetailsColWr>
                            <UiOrderDetailsColWr>
                                <UiOrderDetailsColName colName="Date" />
                                <UiOrderDetailsColLabel label="Monday 22nd March 2023" />
                            </UiOrderDetailsColWr>
                        </UiCol>
                        <UiCol lg="4">
                            <UiOrderDetailsColWr>
                                <UiOrderDetailsColName colName="Goal Info" />
                                <UiOrderDetailsColLabel label="London version 3 trip" />
                            </UiOrderDetailsColWr>
                            <UiOrderDetailsColWr>
                                <UiOrderDetailsColName colName="Points Total" />
                                <UiOrderDetailsColLabel label="4,750 Points" />
                            </UiOrderDetailsColWr>
                        </UiCol>
                        <UiCol lg="4">
                            <UiOrderDetailsLastColWr>
                                <UiOrderDetailsLastCol>
                                    <UiOrderDetailsColWr>
                                        <UiOrderDetailsColName colName="Status" />
                                        <UiHistoricGoalColStatus status="Completed" />
                                    </UiOrderDetailsColWr>
                                    <UiOrderDetailsColWr>
                                        <UiOrderDetailsColName colName="Participants" />
                                        <UiOrderDetailsColValidUnit validUnit="10" />
                                    </UiOrderDetailsColWr>
                                </UiOrderDetailsLastCol>
                                <UiOrderDetailsLastColBtnWr>
                                    <UiButtonPrimary btnName="View Goal" size="45" />
                                </UiOrderDetailsLastColBtnWr>
                            </UiOrderDetailsLastColWr>
                        </UiCol>
                    </UiSingleRow>
                </UiOrderDetails>
                <div className="p-3">
                    <UiSingleRow className="sb-historic-goals">
                        <UiCol lg="4" xl="4">
                            <div className='sb-historic-goals__img-wrapper'>
                                <div className='sb-historic-goal-overlay'></div>
                                <img src={London} className="img-fluid sb-product-info-img sb-product-info-lg" />
                            </div>
                        </UiCol>
                        <UiCol lg="8" xl="8">
                            <UiProductContent>
                                <UiProductContentSubTitle subtitle="Lorem Epsum Goal" />
                                <UiProductContentDescription description="Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna." />
                                <UiSingleRow className="mt-3 sb-voucher-wallet-btn-wr">
                                </UiSingleRow>
                            </UiProductContent>
                        </UiCol>
                    </UiSingleRow>
                </div>
            </UiVoucherDetailsWr>
        </>
    )
}
